import React, { useState, useEffect, useRef } from 'react'
import { Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { BiX } from 'react-icons/bi'

// Single-input modal used for both "Create folder" (create) and "Rename folder".
// Clean, header-less layout (no colored header band) — title + optional subtitle
// + one input, matching the folder design and the library modals. Does NOT
// hard-code any axios call: the host wires onSave to folderService. Rejects
// empty / whitespace-only names (minimum 2 characters).
const FolderNameModal = ({
  open,
  onClose,
  onSave,
  initialName,
  title,
  subtitle,
  confirmLabel,
}) => {
  const [name, setName] = useState(initialName || '')
  const inputRef = useRef(null)

  useEffect(() => {
    setName(initialName || '')
  }, [initialName, open])

  const trimmed = name ? name.trim() : ''
  const isDisabled = trimmed.length < 2

  const handleSave = () => {
    if (isDisabled) {
      return
    }
    if (onSave) {
      onSave(trimmed)
    }
  }

  return (
    <Modal
      isOpen={open}
      centered
      onOpened={() => {
        // Place the cursor in the name field as soon as the modal opens, so the
        // user doesn't have to click into it (TBV-726).
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }}
    >
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-start">
          <h5 className="folder-modal-title mb-0">{title || 'Create folder'}</h5>
          <BiX
            className="cursor-pointer"
            color="#6c757d"
            size={26}
            onClick={() => onClose()}
          />
        </div>
        {subtitle ? (
          <p className="folder-modal-subtitle mt-1 mb-0">{subtitle}</p>
        ) : null}
        <Input
          className="folder-modal-input mt-3"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Folder name"
          innerRef={inputRef}
        />
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <Button
          className="folder-btn-cancel"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          disabled={isDisabled}
          className="folder-btn-primary"
          onClick={handleSave}
        >
          {confirmLabel || 'Create folder'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FolderNameModal
